import React from "react";
import { Section } from "components/section";
import { Box } from "@chakra-ui/react";

export function PricingHeroBg() {
  return (
    <>
      <Section
        as="div"
        themeBgColor="new.blue.150"
        my={0}
        pos="absolute"
        inset={0}
        bottom="auto"
        height={{ base: "20%", md: "40%" }}
        bg="new.blue.150"
      />
      <Section as="div" py={0} pos="absolute" inset={0} top="auto" height={{ base: "80%", md: "60%" }} bg="white" />
      <Box
        pos="absolute"
        left={0}
        right={0}
        top={{ base: "15%", md: "30%" }}
        height={{ base: "20%", md: "25%" }}
        bgGradient="linear(to-b, new.blue.150, white)"
      />
    </>
  );
}
